/* eslint-disable eqeqeq */
/* eslint-disable no-undefined */
/**
 * Elevate Fetch Shim
 *
 * Some third-party scripts (e.g. FastBundle) monkey-patch `window.fetch`
 * in a way that breaks POST requests with JSON bodies (calling `.includes`
 * on non-string values). This shim routes all Voyado Elevate API requests
 * through an unpatched fetch implementation, while leaving all
 * other fetch calls untouched.
 *
 * Usage: import this file once before making any Elevate API calls.
 */

export function elevateFetchShim(): void {
  const orig = window.fetch.bind(window);

  window.fetch = function(input: RequestInfo, init?: RequestInit) {
    // 1) Normalize URL (handle Request objects)
    let url: string | Request = input as any;
    if (typeof input !== 'string') {
      const req = input as Request;
      url = req?.url ?? String(req ?? '');
    }

    // 2) Normalize init
    const safeInit: RequestInit = init ? { ...init } : {};

    // 3) Normalize headers to a Headers instance
    const hdrs = new Headers(safeInit.headers as any);
    safeInit.headers = hdrs;

    // 4) If body is a non-string (and not FormData/Blob/etc.), JSON-stringify it
    const hasBody =
      safeInit && Object.prototype.hasOwnProperty.call(safeInit, 'body');

    const isStringBody = typeof (safeInit as any).body === 'string';
    const isFormData = typeof FormData !== 'undefined' && (safeInit as any).body instanceof FormData;
    const isBlob = typeof Blob !== 'undefined' && (safeInit as any).body instanceof Blob;

    if (hasBody && !isStringBody && !isFormData && !isBlob && (safeInit as any).body != null) {
      try {
        (safeInit as any).body = JSON.stringify((safeInit as any).body);
        hdrs.set('Content-Type', 'application/json');
      } catch {
        // if stringify fails, drop body to avoid wrapper crashes
        (safeInit as any).body = undefined;
      }
    }

    // 5) Call the real fetch
    return orig(url as any, safeInit);
  };
}